<template>
  <v-container>
    <div class="text-h6 primary--text">Sorry, this page does not exist.</div>
    <router-link to="/">Home</router-link>
  </v-container>
</template>
<script>
export default {};
</script>